import { AutoComplete } from 'primeng/autocomplete'

import { checkIsElementAttached } from '../../layout/utils'

export function patchAutoComplete() {
  /**
   * Patch the `Autocomplete::hide` method to fix stale overlays due to custom route reuse
   *
   * PrimeNG overlays attach their content to a separate part of the DOM (outside the Angular component tree)
   * When using a custom route reuse strategy, the normal component destruction does not occur,
   * so the overlay may remain visible in the DOM even though its component is detached
   */
  const orig__AutoComplete_hide = AutoComplete.prototype.hide
  AutoComplete.prototype.hide = function (...args) {
    orig__AutoComplete_hide.call(this, ...args)

    setTimeout(() => {
      if (!checkIsElementAttached(this.el.nativeElement)) {
        this.cd.detectChanges()
      }
    }, 32)
  }

  /**
   * Path the `Autocomplete::show` method to fix a problem focusing the selected option
   */
  const orig__AutoComplete_show = AutoComplete.prototype.show
  AutoComplete.prototype.show = function (...args) {
    setTimeout(() => {
      const focusedOptionIndex =
        this.focusedOptionIndex() !== -1
          ? this.focusedOptionIndex()
          : this.overlayVisible && this.autoOptionFocus
            ? this.findFirstFocusedOptionIndex()
            : -1

      if (focusedOptionIndex !== this.focusedOptionIndex()) {
        this.focusedOptionIndex.set(focusedOptionIndex)
      }

      if (this.overlayVisible) {
        this.scrollInView(this.focusedOptionIndex())
      }
    }, 32)

    return orig__AutoComplete_show.call(this, ...args)
  }
}
